import { Expedition } from '@app/shared/expedition/models/expedition.model'
import { Typology } from '@app/shared/traceability/models/typology.enum'
import { Traceability } from '@app/shared/traceability/models/traceability.model'
import { TraceabilityRequest } from '@app/shared/traceability/models/traceability-request.model'

export class Exercise {
  /** Type of the exercise */
  typology: Typology

  /** Items */
  traceabilities: Traceability[]

  /** The expeditions for the traceabilities of this exercise */
  expeditions: Expedition[]

  /** The request that lead to this exercise */
  request: TraceabilityRequest

  get categories(): [string[], string[]] {
    const [prim, sec]: [Set<string>, Set<string>] = this.traceabilities.reduce(
      (prev: [Set<string>, Set<string>], curr: Traceability) => {
        const primSet: Set<string> = prev[0]
        const secSet: Set<string> = prev[1]
        if (curr.category.primary && !primSet.has(curr.category.primary)) {
          primSet.add(curr.category.primary)
        }
        if (curr.category.secondary && !secSet.has(curr.category.secondary)) {
          secSet.add(curr.category.secondary)
        }
        return [primSet, secSet]
      },
      [new Set(), new Set()]
    ) as [Set<string>, Set<string>]

    const categories: [string[], string[]] = [[...prim], [...sec]]
    return categories
  }

  constructor(exercise: Partial<Exercise>) {
    this.traceabilities = exercise.traceabilities || []
    this.expeditions = exercise.expeditions || []
    this.typology = exercise.typology || Typology.upstream
    this.request = new TraceabilityRequest(exercise.request)

    // Parse traceabilities to make sure we have a class instance instead of a simple js object
    this.traceabilities = this.traceabilities.map((t) => new Traceability(t))
    this.expeditions = this.expeditions.map((e) => new Expedition(e))
  }
}
